// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3c1AS","noInteraction":"EventWrapper_noInteraction__3UpGW"};